// extracted by mini-css-extract-plugin
export default {"container":"Vea-z","innerContainer":"Wea-z","multipleLines":"Xea-z","heading":"Yea-z","content":"Zea-z","linkColor":"_ea-z"};